<div [class]="wrapperClass + ' text-start pmultiselectwrapper'">
  @if (label && label.length) {
    <label (click)="control.enabled && openDropdown($event);" [for]="id + '_input'">
      {{ label }}
      @if ((controlIsRequired$ | async) && showRequiredStar) {
        <em class="text-danger">*</em>
      }
    </label>
  }
  <p-multiselect #multiSelect
                 [autofocus]="false"
                 [appendTo]="appendTo"
                 (onPanelHide)="currentDropdownIcon = 'fa fa-fw fa-caret-down'"
                 (onPanelShow)="currentDropdownIcon = 'fa fa-fw fa-caret-up'"
                 [class.disabled]="control?.disabled"
                 [class.readonly]="readonly"
                 [class]="inputClass"
                 [dropdownIcon]="currentDropdownIcon"
                 [filter]="minItemsForFilter !== false  && itemsForTemplate.length >= minItemsForFilter"
                 [formControl]="control"
                 [inputId]="id + '_input'"
                 [options]="itemsForTemplate"
                 [placeholder]="placeholder"
                 [readonly]="readonly"
                 [showHeader]="minItemsForFilter !== false && itemsForTemplate.length >= minItemsForFilter || showToggleAll"
                 [showToggleAll]="showToggleAll">
    <!--<option *ngIf="includePleaseSelect" [value]="null" disabled>{{'label.dropdownitem.pleaseSelect'}}</option>
    <ng-container *ngIf="!translateItems">
      <option *ngFor="let o of items" [disabled]="o.disabled" [ngValue]="o.value">{{o.label}}</option>
    </ng-container>
    <ng-container *ngIf="translateItems">
      <option *ngFor="let o of items" [disabled]="o.disabled" [ngValue]="o.value">{{o.label}}</option>
    </ng-container>-->
  </p-multiselect>
  <input-error-output [control]="control"></input-error-output>
</div>
